import React, {useState} from "react";
import './Speech.css';
import Osc1 from "../components/Osc1";
import Filter from "../components/Filter";
import Visualizer from "../components/Visualizer";
import {Link} from "react-router-dom";


let actx = new AudioContext();

let out = actx.destination;

let osc1 = actx.createOscillator();
let gain1 = actx.createGain();
let filter = actx.createBiquadFilter();
let isOscClicked=false;
let isOscClicked2=true;

osc1.connect(gain1);
gain1.connect(filter);
filter.connect(out);


export default function Speech(){

const changeValueInOsc=(e)=>{
	let {value, id} = e.target;
	setOsc1Set({
		...osc1Set,
		[id]: value,
		type: osc1.type,
	});

	osc1[id].value = value;
}

const [osc1Set, setOsc1Set] = useState({
	frequency: osc1.frequency.value,
	detune: osc1.detune.value,
	type: osc1.type,
});

const [filterSettings, setFilterSettings] = useState({
	frequency:filter.frequency.value,
	detune:filter.detune.value,
	Q:filter.Q.value,
	gain: filter.gain.value,
	type:filter.type,
});

const [soundSettings, setSoundSettings] = useState({
	volume:1,
	bass:0,
	mid:0,
	treble:0,
});

const [isRealTimeVisualizerClicked, setIsRealTimeVisualizerClicked] = useState(false);

const [isRecording, setIsRecording] = useState(false);

const changeOscType = (e)=>{
	let id = e.target.id;
	osc1.type = id;
	setOsc1Set({
		...osc1Set,
		type: id,
	});
}

const changeFilter = e =>{
	let {value, id} = e.target;
	setFilterSettings({
		...filterSettings,
		[id]: value,
	});
	filter[id].value = value;
}

const changeSound = e =>{
	let {value, id} = e.target;
	setSoundSettings({
		...soundSettings,
		[id]: value,
	});
		bassEQ = new BiquadFilterNode(context, {
		type: 'lowshelf',
		frequency: 500,
		gain: soundSettings["bass"].value
	});
		midEQ = new BiquadFilterNode(context, {
		type: 'peaking',
		Q: Math.SQRT1_2,
		frequency: 1500,
		gain: soundSettings["mid"].value
	});
		trebleEQ = new BiquadFilterNode(context, {
		type: 'highshelf',
		frequency: 3000,
		gain: soundSettings["treble"].value
	});
}

const changeFilterType = e =>{
	let {id} = e.target;
	setFilterSettings({...filterSettings, type: id});
	filter.type=id;
}


URL = window.URL || window.webkitURL;

let gumStream, recorder, chunks = [], extension;

if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')){
	extension="webm";
}
else{
	extension="ogg"
}
function startRecording() {
	let constraints = {audio: true}


	chunks=[];
	navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {

		gumStream = stream;
		let options = {
			audioBitsPerSecond :  256000,
			videoBitsPerSecond : 2500000,
			bitsPerSecond:       2628000,
			mimeType : 'audio/'+extension+';codecs=opus'
		}

		recorder = new MediaRecorder(stream, options);
		recorder.ondataavailable = function(e){

			chunks.push(e.data);
			if (recorder.state == 'inactive') {
				const blob = new Blob(chunks, { type: 'audio/'+extension, bitsPerSecond:128000});
				createDownloadLink(blob)
			}
		};

		recorder.onerror = function(e){
			console.log(e.error);
		}
		recorder.start();
	}).catch(function(err) {});
}


/*function pauseRecording(){
	if (recorder.state=="recording"){
		recorder.pause();
	}else if (recorder.state=="paused") {
		recorder.resume();
	}
}*/

function stopRecording() {
	recorder.stop();
	gumStream.getAudioTracks()[0].stop();
}

const [urlOf, setUrlOf] = useState("");

function createDownloadLink(blob) {
	let url = URL.createObjectURL(blob);
	let au = document.createElement('audio');
	let li = document.createElement('li');
	let link = document.createElement('a');

	au.controls = true;
	au.src = url;
	setUrlOf(url);

	link.href = url;
	link.download = new Date().toISOString() + '.'+extension;
	link.innerHTML = link.download;

	li.appendChild(au);
	//li.appendChild(link);

	document.getElementById("recordingsList").innerHTML = "";

	document.getElementById("recordingsList").appendChild(li);
}

const context = new AudioContext();
const context2 = new AudioContext();
const analyserNode = new AnalyserNode(context, {fftSize: 256});

let gainNode = new GainNode(context, { gain: soundSettings["volume"].value})
let bassEQ = new BiquadFilterNode(context, {
	type: 'lowshelf',
	frequency: 500,
	gain: soundSettings["bass"].value
});
let midEQ = new BiquadFilterNode(context, {
	type: 'peaking',
	Q: Math.SQRT1_2,
	frequency: 1500,
	gain: soundSettings["mid"].value
});
let trebleEQ = new BiquadFilterNode(context, {
	type: 'highshelf',
	frequency: 3000,
	gain: soundSettings["treble"].value
});
let source;

async function setupContext(){
	const sound = await getSound();

	/*const volume = document.getElementById('volume')
	const bass = document.getElementById('bass')
	const mid = document.getElementById('mid')
	const treble = document.getElementById('treble')*/


	if(context.state === 'suspended'){
		await context.resume();
	}

	source = context.createMediaStreamSource(sound);
	source.connect(analyserNode)

}

let streamToStop;

function getSound(){
	resize();
	return navigator.mediaDevices.getUserMedia({
		audio:{
			echoCancellation: true,
			autoGainControl: false,
			noiseSuppression: true,
			latency: 0,
		},
		function(stream){
			streamToStop=stream.getAudioTracks()[0]
		}
	});
}

function drawVisualizer(){
	const visualizer = document.getElementById("visualizer");

	try {
		requestAnimationFrame(drawVisualizer);
		const bufferLength = analyserNode.frequencyBinCount;
		const dataArray = new Uint8Array(bufferLength);

		analyserNode.getByteFrequencyData(dataArray);
		const width = visualizer.width;
		const height = visualizer.height;

		const barWidth = width / bufferLength;

		const canvasContext = visualizer.getContext('2d');
		canvasContext.clearRect(0, 0, width, height);

		dataArray.forEach((item, index) => {
			const y = item / 255 * height / 2
			const x = barWidth * index

			canvasContext.fillStyle = `hsl(${y / height * 400}, 100%, 50%)`
			canvasContext.fillRect(x, height - y, barWidth, y)

		});
	}
	catch (e){}

}

function resize() {
	const visualizer = document.getElementById("visualizer");
	visualizer.width = visualizer.clientWidth * window.devicePixelRatio
	visualizer.height = visualizer.clientHeight * window.devicePixelRatio
}


let yodelBuffer;

function play() {
	window.fetch(urlOf)
		.then(response => response.arrayBuffer())
		.then(arrayBuffer => context2.decodeAudioData(arrayBuffer))
		.then(audioBuffer => {
			yodelBuffer = audioBuffer;
			const source = context2.createBufferSource();
			source.buffer = audioBuffer;
			source.connect(context2.destination);
			source.start();
		});
}


return(
	<div className='speechContainer'>

		<div className='oscBtns'>
			<button className='btnF' onClick={()=>{
				if(!isOscClicked) {
					try {
						isOscClicked=true;
						isOscClicked2=false;
						osc1.connect(gain1);
						osc1.start();
					} catch (e) {
					}
				}
			}}>START</button>

			<button className='btnF' onClick={()=>{
				if(!isOscClicked2) {
					try {
						isOscClicked=false;
						isOscClicked2=true;
						osc1.disconnect(gain1);
					} catch (e) {}
				}
			}}>STOP</button>
		</div>

		<Osc1 change={changeValueInOsc} settings={osc1Set} changeType={changeOscType}/>

		<Filter change={changeFilter} settings={filterSettings} changeFilterType={changeFilterType}/>

		{/*<div className="grid">
			<label htmlFor="volume">Volume</label>
			<input onChange={changeSound} type="range" min="0" max="1" value={soundSettings['volume']} step=".01" id="volume"/>
			<label htmlFor="bass">Bass</label>
			<input onChange={changeSound} type="range" min="-30" max="30" value={soundSettings['bass']} id="bass"/>
			<label htmlFor="mid">Mid</label>
			<input onChange={changeSound} type="range" min="-30" max="30" value={soundSettings['mid']} id="mid"/>
			<label htmlFor="treble">Treble</label>
			<input onChange={changeSound} type="range" min="-30" max="30" value={soundSettings['treble']} id="treble"/>
		</div>*/}


		<p style={{fontSize:"35px"}}>Dyktafon</p>
		<div className='Records'>
			<div id="controls">
				<button id="recordButton" className='btnRecording' onClick={()=>startRecording()}>NAGRAJ</button>
				{/*<button id="pauseButton" className='btnRecording' onClick={()=>pauseRecording()}>Wstrzymaj</button>*/}
				<button id="stopButton" className='btnRecording' onClick={()=>stopRecording()}>ZAKOŃCZ NAGRYWANIE</button>
			</div>
			<ol id='recordingsList'></ol>
		</div>

		{urlOf!=''?<button onClick={() => {
			play();
		}}>Odtwórz nagranie</button>:null}



		<br/><br/><br/><br/>
		<p>Wizualizator dźwięku z mikrofonu w czasie rzeczywistym.</p>

		<div className='visualizerBtnAField'>
			<p><canvas id='visualizer'></canvas></p>
			{!isRealTimeVisualizerClicked?<button className='btnRecording' onClick={()=>{
				setupContext();
				drawVisualizer();
				setIsRealTimeVisualizerClicked(true);
			}}>WŁĄCZ WIZUALIZATOR</button>:<button className='btnRecording' onClick={()=>{
				try {
					window.location.reload(false);
					//streamToStop.getTracks().forEach(track => track.stop());
				}
				catch (e){}
			}}>Wyłącz</button>}
		</div>

		<Visualizer record={urlOf}/>

		<br/><br/><br/>
		<h1><Link to='/dzwiek/teoria'><button className='btnRecording'>Teoria</button></Link></h1>

		<br/><br/><br/>

	</div>
);
}